import { Injectable, signal, inject } from '@angular/core';
import { FleetDto } from '../interfaces';
import { Observable, Subject } from 'rxjs';
import { RestApiService } from '@core/services/rest-api.service';

@Injectable({ providedIn: 'root' })
export class HistoricalPositionService {
  private api = inject(RestApiService);

  selectedHistoricalDateTime = signal<string | undefined>(undefined);
  readonly historicalPositionFetchTrigger$ = new Subject<string | undefined>();

  fetchHistoricalFleetPositions(
    dateAndTime: string,
    fleetIds: string[]
  ): Observable<FleetDto[]> {
    return this.api.postCustom('Fleet/getPositions', {
      DateAndTime: dateAndTime,
      FleetIDs: fleetIds,
    });
  }
}
